import React, { useEffect, useState } from "react";
import ModalLoadingFull from "../utils/ModalLoadingFull";
import { postNotification } from "../utils/Notifications";
import { redirectUrlAuth, urlParams } from "../utils/urlParams";
import { postData } from "../utils/APIUtilities";
import { decodeToken } from "react-jwt";

import OICSignup from "./OICSignup";
import OICLinkAccount from "./OICLinkAccount";
import { getEnvironmentVariable } from "../global/environmentVariables";

const AUTH_HOSTED_UI = `https://${window.location.host}/`;

export default function OICVerify() {
  const { code, state, redirect_uri } = urlParams();
  const [tokens, setTokens] = useState(null);
  const [identityToken, setIdentityToken] = useState(null);

  const _redirect_uri = redirect_uri || localStorage?.getItem("redirect_uri");
  const _state = state || localStorage?.getItem("state");
  const _oic_link_username = localStorage?.getItem("oic_link_username");

  // const _redirect_uri = redirect_uri || localStorage?.getItem("redirect_uri");

  const [flowStep, setFlowStep] = useState(0);

  useEffect(() => {
    const process = async () => {
      try {
        if (code) {
          const customUrl = getEnvironmentVariable("API_URL").replace(
            "/v1",
            ""
          );

          // New endpoint, should return the tokens
          const oicverify = await postData(
            `/oauth/token`,
            {
              code: code,
              grant_type: "authorization_code",
              redirect_uri: `${AUTH_HOSTED_UI}oauth2/idpresponse`,
            },
            null,
            customUrl
          );

          setTokens(oicverify);
        }
      } catch (err) {
        console.error(err);
        postNotification("error", err);
      }
    };

    process();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const process = async () => {
      try {
        let _identityToken = decodeToken(tokens?.idToken);

        if (_identityToken?.forceLinkAccount === "true" || _oic_link_username) {
          // Need to link to existing BCP account
          setFlowStep(1);
          setIdentityToken(_identityToken);
        } else if (
          _identityToken?.postExternalLinkFlow === "true" ||
          !_identityToken.given_name ||
          !_identityToken.family_name ||
          !_identityToken.email
        ) {
          // Need to sign up for new account entirely
          setFlowStep(2);
          setIdentityToken(_identityToken);
        } else {
          // Login redirect

          // New endpoint, should return the auth code
          const apiData = await postData(
            "/oauth/storetoken",
            {
              token: tokens.refreshToken,
              redirect_uri: _redirect_uri,
            },
            null,
            getEnvironmentVariable("API_URL").replace("/v1", "")
          );

          // Regular login redirect
          await redirectUrlAuth({
            cognitoProps: {
              code: apiData?.code || apiData?.authorizationCode,
              state: _state,
            },
            redirect_uri: apiData?.redirect_uri || _redirect_uri,
          });
        }
      } catch (err) {
        console.error(err);
        postNotification("error", err);
      }
    };

    if (tokens) process();

    // eslint-disable-next-line
  }, [tokens]);

  // Link to existing BCP account
  if (flowStep === 1) {
    return (
      <OICLinkAccount
        tokens={tokens}
        identityToken={identityToken}
        oic_link_username={_oic_link_username}
        state={state}
      />
    );
  }

  // Sign up for new account entirely
  if (flowStep === 2)
    return (
      <OICSignup
        tokens={tokens}
        identityToken={identityToken}
        setIdentityToken={setIdentityToken}
      />
    );

  return <ModalLoadingFull />;
}
